<template>
    
     <div class="textblocks" id="spiegazioni" >

      <div  class="textblock align0 lframe">
        {{ intro1 }}
      </div>

      <div class="textblock align1">
        {{ intro2 }}
      </div>

      <div class="textblock align2">
      <img src="@/assets/images/idea.svg" />
        <div>
          <h2>{{ idea1 }}</h2>
          {{ idea2 }}
        </div>
      </div>


      <div class="textblock align3">
      <img src="@/assets/images/contatto.svg" />
        <div><h2> {{ contatto1 }}</h2>
      {{ contatto2 }}
      <a :href="company_mailto">{{ company_email }}</a>
      {{ contatto3 }}
      {{ company_tel }}
        </div>
      </div>


    <div class="textblock align2">
      <img src="@/assets/images/pensi.svg" />
        <div><h2>{{ pensi1 }}</h2>
      {{ pensi2 }}
        </div>
      </div>



      <div class="textblock align3">
      <img src="@/assets/images/ordine.svg" />
        <div><h2>{{ ordine1 }}</h2>
        {{ ordine2 }}
      </div>
      </div>
      



    <div class="textblock align2">
      <img src="@/assets/images/sviluppo.svg" />
        <div><h2>{{ sviluppo1 }}</h2>
        {{ sviluppo2 }}
        </div>
      </div>


      <div class="textblock align3">
      <img src="@/assets/images/prototipo.svg" />
        <div><h2>{{ prototipo1 }}</h2>
        {{ prototipo2 }}
      </div>
      </div>

        <div class="textblock align2">
      <img src="@/assets/images/code.svg" />
        <div><h2>{{ firmware1 }}</h2>
        {{ firmware2 }}
      </div>
      </div>


      <div class="textblock align3">
      <img src="@/assets/images/tuttobene.svg" />
        <div><h2>{{ tuttobene1 }}</h2>
        {{ tuttobene2 }}
      </div>
      </div>



        <div class="textblock align2">
      <img src="@/assets/images/produzione.svg" />
      <div><h2>{{ produzione1 }}</h2>
        {{ produzione2 }}
      </div>
      </div>


      
      <h3 class="cominciamo"> {{ cominciamo1 }}<br/>{{ cominciamo2 }}</h3>
      
      <div class="arrow_up"><a href="#newlabapp"><img src="@/assets/images/arrow_up.svg"></a></div>

    </div>
 
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"
import companymixin from "../mixins/companymixin.js"


// eslint-disable-next-line no-unused-vars

export default {
  name: "cmpspiegazioni",
  mixins:[multilangmixin,companymixin],
    

  data(){
      return {

            };
  },

  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);

  },

  computed:{
      intro1(){
          return this.fnGetTranslation(this.currentlang,"intro1");
      },
      intro2(){
          return this.fnGetTranslation(this.currentlang,"intro2");
      },
      idea1(){
          return this.fnGetTranslation(this.currentlang,"idea1");
      },
      idea2(){
          return this.fnGetTranslation(this.currentlang,"idea2");
      },
      contatto1(){
          return this.fnGetTranslation(this.currentlang,"contatto1");
      },
      contatto2(){
          return this.fnGetTranslation(this.currentlang,"contatto2");
      },
      contatto3(){
          return this.fnGetTranslation(this.currentlang,"contatto3");
      },
      pensi1(){
          return this.fnGetTranslation(this.currentlang,"pensi1");
      },
      pensi2(){
          return this.fnGetTranslation(this.currentlang,"pensi2");
      },
      ordine1(){
          return this.fnGetTranslation(this.currentlang,"ordine1");
      },
      ordine2(){
          return this.fnGetTranslation(this.currentlang,"ordine2");
      },
      sviluppo1(){
          return this.fnGetTranslation(this.currentlang,"sviluppo1");
      },
      sviluppo2(){
          return this.fnGetTranslation(this.currentlang,"sviluppo2");
      },
      prototipo1(){
          return this.fnGetTranslation(this.currentlang,"prototipo1");
      },
      prototipo2(){
          return this.fnGetTranslation(this.currentlang,"prototipo2");
      },
      firmware1(){
          return this.fnGetTranslation(this.currentlang,"firmware1");
      },
      firmware2(){
          return this.fnGetTranslation(this.currentlang,"firmware2");
      },
      tuttobene1(){
          return this.fnGetTranslation(this.currentlang,"tuttobene1");
      },
      tuttobene2(){
          return this.fnGetTranslation(this.currentlang,"tuttobene2");
      },
      produzione1(){
          return this.fnGetTranslation(this.currentlang,"produzione1");
      },
      produzione2(){
          return this.fnGetTranslation(this.currentlang,"produzione2");
      },
      cominciamo1(){
          return this.fnGetTranslation(this.currentlang,"cominciamo1");
      },
      cominciamo2(){
          return this.fnGetTranslation(this.currentlang,"cominciamo2");
      },

  },


  methods:{


  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    



  .cominciamo{
    margin-top: 50px;
  }

  .global_vmarginsmall{
    margin-top: 20px;

  }



  .textblocks
  {
    font-size: 1em;

    margin-top: 50px;

    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 0px;

    position: relative;
    
  }

  .textblocks h3
  {
    font-size: 2.2em;
    font-weight: 600;

    margin-left: 0px;
    margin-right: 0px;
    text-align: center;
    
  }

  .textblock{
    white-space: pre-line;
    font-weight: 600;
    padding:25px;

  }


  .textblock img{

    margin-left: 0px;

    height: 70px;
  }

/*
  .textblock div{

    
  }
  */

  .textblock div h2{

    font-weight: 700;
    font-size: 1.2em;  
  }


  .textblock div a{

    color: black;
    text-decoration: none;
  }


  .textblock div a:visited{

    color: black;
    text-decoration: none;
  }

  .textblock div a:active{

    color: black;
    text-decoration: none;
  }

  .textblock div a:hover{

    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-color: #ffdd00;
    text-decoration-thickness: 0.3em;
  }

  .lframe{

    background-image: url("~@/assets/images/lframe.svg");
    background-size: 80px 80px;
    background-repeat: no-repeat;
    

  }

/*
  .align0
  {
    
  }

  .align1
  {

  }

  .align2
  {

  }

  .align3
  {

  }

*/


  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
        
      .textblock{

        display: table;
      }


      .textblock img{

        float: left;
      }


      .textblock div{
         display: inline-block;
         margin-left:20px;
         max-width: 350px;
         
      }



      .align0
      {
        margin-left: 10%;
        margin-right: 10%;
        
      }
  

            
      .align1
      {
        margin-left: 20%;
        margin-right: 10%;
        
      }


      .align2
      {
        margin-left: 30%;
        margin-right: 10%;
        
      }

      .align3
      {
        margin-left: 40%;
        margin-right: 10%;
        
      }
      


      .arrow_up{
        position: absolute;
        right: 5vh;
        bottom: 5vh;
        
      }

 

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
  


  

    .textblock img{
      margin-left: auto;
      margin-right: auto;
      display: block;
   }


    .textblock div{
      margin-top:25px;
      
   }

   .align0
    {
      margin-left: 5%;
      margin-right: 5%;
      
    }


    .align1
    {
      margin-left: 5%;
      margin-right: 5%;
      
    }

    .align2
    {
      margin-left: 5%;
      margin-right: 5%;
      
    }

    .align3
    {
      margin-left: 5%;
      margin-right: 5%;
      
    }


    .arrow_up{
      position: absolute;
      right: 5vh;
      bottom: 15vh;
      
    }
 

    .arrow_up a img{
        width: 10vw;    
    }


  }


</style>
